import {Routes} from '@angular/router';
import {AuthGuard} from '../core/security/auth-guard.service';
import {ModulesEnum} from '../core/security/modules.enum';
import {RolesEnum} from '../core/security/roles.enum';
import {MenuGroupEnum} from '../core/security/menu-group.enum';
import {ProMessagingWhatsAppTemplateListComponent} from './list/list.component';
import {ProMessagingWhatsAppTemplateEditComponent} from './edit/edit.component';

export const routes: Routes = [
  {
    path: 'list',
    component: ProMessagingWhatsAppTemplateListComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.ProMessagingGroup,
      package: ModulesEnum.MessagingWhatsAppTemplateModule,
      permissions: [
        RolesEnum.MessagingWhatsAppTemplateView,
        RolesEnum.MessagingWhatsAppTemplateEdit,
        RolesEnum.MessagingWhatsAppTemplateDelete
      ],
      meta: {
        title: 'WhatsApp Templates',
        override: true,
        description: 'WhatsApp Messages templates for initial conversation',
        inSideMenu: true,
        iconClass: 'material-icons',
        iconClassCode: 'quickreply',
        showDisabled: false
      }
    }
  },
  {
    path: 'edit',
    canActivate: [AuthGuard],
    children: [
      {
        path: ':id',
        component: ProMessagingWhatsAppTemplateEditComponent,
        canActivate: [AuthGuard],
        data: {
          menuGroup: MenuGroupEnum.ProMessagingGroup,
          package: ModulesEnum.MessagingWhatsAppTemplateModule,
          permissions: [RolesEnum.MessagingWhatsAppTemplateEdit, RolesEnum.MessagingWhatsAppTemplateDelete],
          meta: {
            title: 'Edit WhatsApp Template',
            override: true,
            description: 'WhatsApp templates',
            inSideMenu: false,
            iconClass: 'material-icons',
            iconClassCode: 'quickreply',
          }
        }
      }
    ]
  },
];
